import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { DrawComponent } from './draw.component';

const routes: Routes = [{ path: 'draw', component: DrawComponent, data: { title: 'Draw' } }];

/* loadChildren: () => import('../feature/path/sample- 
tags.module').then(m => m.CreateLinksModule) */

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class DrawRoutingModule { }
